import { formatDate } from './formatDate';
import { getNowTimestamp } from './getNowTimestamp';

export function getFormattedDateNow() {
	const nowTimestamp = getNowTimestamp('YYYYMMDD HH:MM');
	return formatDate(nowTimestamp, true)
}
